export const dialogHeaderMsg = 'Removing ring subscription';
export const titleMsg = 'Do you want to terminate ring subscription or detach ring from voice subscription?';
export const optionOneMsg = 'I want to terminate ring subscription';
export const optionOneDetailMsg =
  'Ring services will be removed from user {}. Extension number {} and corporate number {} will be released.';
export const optionTwoMsg = 'I want to detach ring from voice subscription';
export const optionTwoDetailMsg = `User's {} ring services, extension number {} and corporate number {} will stay intact. If you want to use ring service without mobilephone, you must get a VOIP phone`;
